import { newPageInfo } from "@hex-insights/router";
import { hubsPageInfo } from "../pageinfo";

export const marketEntryTicketHubPageInfo = newPageInfo({
	title: "Market Entry Tickets",
	description: "Pages related to the Market Entry Ticket model.",
	exact: false,
	to: hubsPageInfo.to + "/market-entry-tickets",
	path: hubsPageInfo.path + "/market-entry-tickets",
	parent: hubsPageInfo,
});
